/* eslint-disable */
import PropTypes from 'prop-types';
import React, { useState } from 'react';

// main components below
import InventoryListTable from './Table';
import SearchInventoryFilter from './Filter';

import './style.scss';

// main component
const ReturnedItemToInventory = ({ departmentID, subTabActiveKey }) => {
  const [searchData, setSearchData] = useState({
    search: '',
  });

  return (
    <div className='admissions-inventory-tab-inventory-items'>
      <SearchInventoryFilter
        searchData={searchData}
        departmentID={departmentID}
        setSearchData={setSearchData}
      />

      <InventoryListTable
        searchData={searchData}
        departmentID={departmentID}
        setSearchData={setSearchData}
        subTabActiveKey={subTabActiveKey}
      />
    </div>
  );
};

ReturnedItemToInventory.defaultProps = {
  departmentID: '',
};

ReturnedItemToInventory.propTypes = {
  departmentID: PropTypes.string,
};

export default ReturnedItemToInventory;
